
angular
	.module('servicepro.centereditor', [
		'ngResource',
		'ng-sortable',
		'ui.bootstrap'
	]);
